export const MIN_ZOOM_TO_SHOW_ROADS = 12;
